const initState = {
  isAdding: false,
  error: null,
}

export default initState
